const root = `td-system/dept/`
const urls = {
  getList: root + 'list'
}

export const getDeptList = obj => {
  return $http.get(urls.getList, obj)
}

export default {
  getDeptList
}
